import { atom, PrimitiveAtom } from 'jotai';

// Types
import {
    MessageFilter,
    SocialInboxMessage
} from '@/components/pages/conversations/SocialInbox/types';

/** ID of the message that is viewed in the chat section of the social inbox. */
export const openedMessageAtom = atom<SocialInboxMessage>(
    null
) as PrimitiveAtom<SocialInboxMessage>;

/** IDs of the selected messages in the social inbox. */
export const selectedMessagesIdsAtom = atom<string[]>([]);

/** Selected secondary filter in the social inbox. */
export const messageFilterSecondaryAtom = atom<MessageFilter>({
    search: '',
    filter: 'all',
    sort: 'newest'
});
